<template>
  <v-container fluid>
    <v-select v-model="gestion" outlined return-object hide-details item-text="gestion" :items="items" label="Gestion" dense></v-select>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      gestion: null,
    };
  },
  watch: {
    gestion(newValue) {
      if (newValue) {
        this.$store.dispatch('gestion/selectGestion', newValue);
      } else {
        this.$store.dispatch('gestion/setGestionNull');
      }
      this.$emit('change', newValue);
    },
  },
  computed: {
    ...mapState({
      items: (state) => state.gestion.items,
      value: (state) => state.gestion.value,
    }),
  },
  mounted() {
    this.gestion = this.value;
  },
};
</script>

<style>
</style>